"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 9H6c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=small-minus.js.map